<template>
    <b-modal ref="mdlRsaAdiProtocolliEditComponent" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg" scrollable>
        <div class="sa-tab-scroll">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">N. Protocollo</label>
                    <b-form-input v-model="jsonData.numeroProtocollo" placeholder="Numero Protocollo"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Data Protocollo</label>
                    <date-picker v-model="jsonData.dataProtocollo" format="DD/MM/YYYY" value-type="timestamp" type="date"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Data Trasmissione</label>
                    <date-picker v-model="jsonData.dataTrasmissione" format="DD/MM/YYYY" value-type="timestamp" type="date"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Autorizzazione</label>
                    <date-picker v-model="jsonData.dataAutorizzazione" format="DD/MM/YYYY" value-type="timestamp" type="date"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Presa in Carico</label>
                    <date-picker v-model="jsonData.dataPresaCarico" format="DD/MM/YYYY" value-type="timestamp" type="date"></date-picker
                    ><!-- Disabilitare questa data in caso di richiesta -->
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Tipologia</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.tipologia" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="value" text-field="text" :options="tipologiaOptions" required></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Livello</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.livello" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="value" text-field="text" :options="livelliOptions" required></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Distretto</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.distretto" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="value" text-field="text" :options="distrettiOptions" required></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Data Inizio Trattamento</label>
                    <date-picker v-model="jsonData.dataInizioTrattamento" format="DD/MM/YYYY" value-type="timestamp" type="date" @change="onChangecalcolaNumeroGiorniTrattamento"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Data Fine Trattamento</label>
                    <date-picker v-model="jsonData.dataFineTrattamento" format="DD/MM/YYYY" value-type="timestamp" type="date" @change="onChangecalcolaNumeroGiorniTrattamento"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Numero Giorni Trattamento</label>
                    <!--           <b-form-input type="number" v-model="jsonData.numeroGiorniTrattamento" placeholder="Numero Giorni Trattamento"></b-form-input> -->
                    <b-input-group class="mb-3">
                        <b-form-input autocomplete="off" id="inline-form-custom-select-pref" v-model="jsonData.numeroGiorniTrattamento" class="mb-2 mr-sm-2 mb-sm-0"></b-form-input>
                        <b-button size="sm" variant="" @click="onClickCalcolaDataFineTrattamento"><b-icon icon="calculator" :disabled="jsonData.dataInizioTrattamento === null"></b-icon></b-button>
                    </b-input-group>
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <b-button variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button variant="outline-success" @click="onClickSalva">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import axios from "axios";

export default {
    name: "RsaAdiProtocolliEditComponent",
    mixins: [UtilityMixin],
    components: { ModalError, DatePicker },
    data() {
        return {
            pathResource: "/rsaadiprotocollo",
            pathResourceTools: "/tools",
            title: "Nuovo Protocollo",
            jsonData: this.getDefaultJsonData(),
            presidio: {},
            tipologiaOptions: [
                { value: null, text: "- Seleziona Valore -" },
                { value: "ATTIVAZIONE", text: "Attivazione" },
                { value: "PROROGA", text: "Proroga" },
                { value: "VARIAZIONE", text: "Variazione" },
                { value: "PROROGA CON CONCLUSIONE", text: "Proroga con conclusione" },
                { value: "CONCLUSIONE", text: "Conclusione" },
            ],
            livelliOptions: [{ value: null, text: "- Seleziona Valore -" }],
            distrettiOptions: [
                { text: "DS Jonio SUD - Cariati", value: "DS_JS_C" },
                { text: "DS Jonio SUD - Rossano", value: "DS_JS_R" },
                { text: "DS Jonio NORD - Trebisacce", value: "DS_JN_T" },
                { text: "DS Jonio NORD - Corigliano", value: "DS_JN_C" },
                { text: "DS Valle Crati - Rende", value: "DS_VC_R" },
                { text: "DS Valle Crati - Acri", value: "DS_VC_A" },
                { text: "DS Cosenza Savuto - Cosenza", value: "DS_CS_C" },
                { text: "DS Cosenza Savuto - Rogliano", value: "DS_CS_R" },
                { text: "DS Tirreno NORD", value: "DS_TN" },
                { text: "DS Tirreno SUD", value: "DS_TS" },
                { text: "DS Esaro Pollino", value: "DS_EP" },
            ],
        };
    },
    mounted() {
        let me = this;
        if (localStorage.getItem("presidio")) {
            me.presidio = JSON.parse(localStorage.getItem("presidio"));
        }
    },
    /*  watch: {
        jsonData: {
            handler(value) {
                console.log("ciato", value);
            },
        },
    }, */
    methods: {
        getDefaultJsonData() {
            return {
                id: null,
                idAccettazione: null,
                numeroProtocollo: "",
                tipologia: null,
                livello: null,
                distretto: null,
                proprietario: "",
                dataProtocollo: new Date().getTime(),
                dataPresaCarico: null,
                dataAutorizzazione: null,
                dataInizioTrattamento: null,
                dataFineTrattamento: null,
                numeroGiorniTrattamento: null,
            };
        },
        show(jsonDataAccettazione) {
            let me = this;
            me.title = "Nuovo Protocollo";
            me.jsonData = me.getDefaultJsonData();
            this.jsonDataAccettazione = jsonDataAccettazione;
            me.jsonData.idAccettazione = jsonDataAccettazione.id;
            this.loadDefaultData();
            me.verificaProtocolliEsistenti();
            me.$refs.mdlRsaAdiProtocolliEditComponent.show();
        },
        showModifica(id, jsonDataAccettazione = null) {
            let me = this;
            me.title = "Modifica Protocollo";
            this.jsonDataAccettazione = jsonDataAccettazione;
            this.loadDefaultData();
            me.loadDataResources(me.pathResource + "/" + id, {}, me.loadDataSuccess, me.loadDataError);
        },
        loadDefaultData() {
            this.livelliOptions = [{ value: null, text: "- Seleziona Valore -" }];
            //    this.distrettiOptions = [];
            this.loadDataSetting();
            this.loadDataDistretti();
        },
        verificaProtocolliEsistenti() {
            let me = this;
            me.loadDataResources(me.pathResource, { idAccettazione: me.jsonDataAccettazione.id }, me.responseVerificaProtocolliEsistentiSuccess, null);
        },
        responseVerificaProtocolliEsistentiSuccess(response) {
            let me = this;
            let list = response.data.data.list ? response.data.data.list : [];
            if (list.length > 0) {
                list.sort((a, b) => b.dataProtocollo - a.dataProtocollo);
                let ultimoProtocollo = list[0];
                if (ultimoProtocollo.dataAutorizzazione) {
                    me.jsonData.dataAutorizzazione = ultimoProtocollo.dataAutorizzazione;
                }
            }
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.$refs.mdlRsaAdiProtocolliEditComponent.show();
        },
        loadDataError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onClickSalva() {
            let me = this;
            me.saveResource(me.pathResource, me.jsonData, me.saveSuccess, me.saveError);
        },
        saveSuccess(response) {
            let me = this;
            me.$bvToast.toast("Protocollo salvato correttamente", {
                title: "Protocollo ADI",
                solid: true,
                variant: "success",
                autoHideDelay: 3000,
                appendToast: true,
            });
            me.$refs.mdlRsaAdiProtocolliEditComponent.hide();
            me.$emit("saveSuccess", response.data.data);
        },
        saveError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onCloseModal() {
            let me = this;
            me.jsonData = me.getDefaultJsonData();
            me.$refs.mdlRsaAdiProtocolliEditComponent.hide();
        },
        onChangecalcolaNumeroGiorniTrattamento() {
            let me = this;
            me.calcolaNumeroGiorniTrattamento(me.jsonData.dataInizioTrattamento, me.jsonData.dataFineTrattamento);
        },
        calcolaNumeroGiorniTrattamento(inizioTrattamento, fineTrattamento) {
            let me = this;
            if (inizioTrattamento && fineTrattamento) {
                let differenza = fineTrattamento - inizioTrattamento;
                me.jsonData.numeroGiorniTrattamento = Math.ceil(differenza / (1000 * 3600 * 24)) + 1;
            }
        },
        onClickCalcolaDataFineTrattamento() {
            let me = this;

            let params = { dataRiferimento: me.jsonData.dataInizioTrattamento, periodoDaModificare: "DAY", valoreDaAggiungere: me.jsonData.numeroGiorniTrattamento - 1 };
            let link = process.env.VUE_APP_PATH_API + me.pathResourceTools + "/modificaData";
            axios
                .get(link, { params: params })
                .then((response) => {
                    me.jsonData.dataFineTrattamento = response.data.data;
                })
                .catch((error) => {
                    this.$bvToast.toast("Errore: " + error.response.data.messaggio, {
                        title: "ATTENZIONE!",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
        loadDataSetting() {
            let path = "/rsasettingspresidi";
            let idPresidio = "";

            if (this.presidio) {
                idPresidio = this.presidio.idPresidio;
            } else {
                idPresidio = this.jsonDataAccettazione.idPresidio;
            }

            this.loadDataResources(path, { idPresidio: idPresidio }, this.resultResponseSettingSuccess, null);
        },

        resultResponseSettingSuccess(response) {
            let settingOptions = response.data.data.list;
            settingOptions.forEach((element) => {
                if (element.setting === this.jsonDataAccettazione.settingDescrizione) {
                    this.loadDataLivelli(element.idRsaSettings);
                }
            });
        },
        loadDataLivelli(idSetting) {
            let path = "/rsasettinglivelli";
            this.loadDataResources(path, { idSetting: idSetting }, this.resultResponseSuccess, null);
        },
        resultResponseSuccess(response) {
            this.livelliOptions = [{ value: null, text: "- Seleziona Valore -" }, ...response.data.data.list.map((element) => ({ text: element.descrizione, value: element.descrizione }))];
        },
        loadDataDistretti() {
            console.log("Distretti");

            //     let path = "/distretti";
            //     this.loadDataResources(path, {}, this.resultResponseDistrettiSuccess, null);
        } /*
        resultResponseDistrettiSuccess(response) {
            this.distrettiOptions = [{ text: "- Seleziona Valore -", value: null }, ...response.data.data.list.map((element) => ({ text: element.descrizione, value: element.codiceDistretto }))];
        }, */,
    },
};
</script>

<style></style>
